// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c233c126","105":"5ce8db38","157":"d3481401","280":"05656999","382":"59306a8a","466":"bcb457d9","536":"bf7af681","671":"dabe9495","780":"9d7fa284","966":"5bd6a574"}[chunkId] + ".chunk.js";
};